<template>
    <div :class="'range-slider ' + (rangeIsCorrect ? 'correct' : 'incorrect')">
        <input :id="sliderId" :data-max="max" :data-min="min" type="text" />
    </div>
</template>

<script>
import { ionRangeSlider } from "ion-rangeslider";

export default {
    name: "RangeSlider",
    data() {
        return {
            sliderId: "rangeSlider_" + Math.random().toString(36).slice(2, 7),
        };
    },
    components: {
        ionRangeSlider,
    },
    props: {
        rangeIsCorrect: {
            default: false,
        },
        modelValue: {
            default: {
                min: -1,
                max: 1,
            },
        },
        min: {
            default: -100,
        },
        max: {
            default: 100,
        },
        step: {
            default: 1,
        },
        unitLabel: {
            default: "ml",
        },
        type: {
            default: "single",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateValues: function (values) {
            this.inputVal.min = values[0];
            this.inputVal.max = values[1];
        },
    },
    mounted() {
        let vm = this;

        setTimeout(function () {
            let slider = jQuery("#" + vm.sliderId).ionRangeSlider(
                {
                    theme: "flat",
                    type: vm.type === "single" ? "single" : "double",
                    from: vm.modelValue.min,
                    to: vm.modelValue.max,
                    step: vm.step,
                    postfix: " " + vm.unitLabel,
                    grid: true,
                    grid_margin: true,
                    grid_snap: true,
                    block: vm.disabled,
                    onFinish: function (data) {
                        vm.updateValues([data.from, data.to]);
                    },
                },
                100
            );
        });
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped></style>
